/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { mock } from '@/axios/fetch';
import { reactive, ref } from 'vue';
import MockPath from '@/mock/mock_api';
import {
  RouteLocationNormalizedLoaded, Router, useRoute, useRouter,
} from 'vue-router';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
// import Mock from 'mockjs';
import { message } from 'ant-design-vue';
import {
  ClassDataCaseAnalysis,
  ClassDataJobView,
  DataCaseAnalysis, DataJobView, JobDetailListItem, JobDetailListTable,
} from './interface';
import { apiQueryJobView } from './jobView';

const mockPath = new MockPath();

/** api 转换 */
const apiQueryDetail = (data: definitions['AssignHomeworkPersonnel'], model: number): JobDetailListItem => ({
  ...data,
  id: data.id!,
  userId: data.userId!,
  userName: data.name!,
  // finishStatus: data.personnelStatus === 0 ? '未完成' : '已完成',
  // jobScore: data.score!,
  // rank: data.ranking!,
  pattern: model ? '考核模式' : '练习模式',
  finishStatus: data.personnelStatus === 0 ? '未完成' : '已完成',
  jobScore: (data.score === undefined) ? '-' : `${data.score}`,
  rank: [undefined, -1].includes(data.ranking) ? '-' : `${data.ranking}`, // -1也展示 “-”，但是-1不能点击
});
const apiListDetail = (list: definitions['AssignHomeworkPersonnel'][], model: number) => list.map((v) => apiQueryDetail(v, model));

export class JobDetailList {
  quering = ref(false);

  deleting = ref(false);

  loadings = reactive({
    release: false,
  })

  activeJobDetail: JobDetailListItem = reactive({}) as JobDetailListItem;

  data: JobDetailListTable = reactive({
    list: [],
    pagination: {
      pageNo: 1,
      pageSize: 12,
      totalRecords: 0,
    },
  })

  columns = ref([
    {
      title: '序号',
      dataIndex: 'jobName',
      width: '10%',
      slots: {
        customRender: 'index',
      },
    },
    {
      title: '账号',
      dataIndex: 'userId',
      width: '25%',
      ellipsis: true,
      key: 'userId',
    },
    {
      title: '姓名',
      dataIndex: 'userName',
      width: '25%',
      ellipsis: true,
      key: 'userName',
    },
    {
      title: '完成状态',
      dataIndex: 'finishStatus',
      width: '25%',
      key: 'finishStatus',
    },
    {
      title: '作业分数',
      dataIndex: 'jobScore',
      width: '15%',
      key: 'jobScore',
    },
    {
      title: '排名',
      dataIndex: 'rank',
      width: '10%',
      key: 'rank',
    },
    {
      title: '操作',
      width: '15%',
      align: 'center',
      slots: {
        customRender: 'operation',
      },
    },
  ])

  activeJobDetailId = ref('');

  homeWorkInfo = reactive<DataJobView>(
    new ClassDataJobView() as DataJobView,
  ); // 作业信息

  assignInfo = reactive<DataCaseAnalysis>(
    new ClassDataCaseAnalysis() as DataCaseAnalysis,
  ); // 案例分析数据

  constructor() {
    console.log();
    // this.queryJobDetailList();
  }

  async queryJobDetailList() {
    // console.log(cloneDeep(this.homeWorkInfo), 'homework');
    this.quering.value = true;
    const qdata = {
      pageNo: this.data.pagination.pageNo,
      pageSize: this.data.pagination.pageSize,
      assignId: this.homeWorkInfo.id,
    };
    // console.log(cloneDeep(qdata), 'homework');
    // const { data } = await mock.post(mockPath.getJobDetailList, qdata);
    const { data } = await axios.listAssignHomeworkPersonnel(qdata);
    this.quering.value = false;
    // console.log(apiListDetail(data.data.list, this.homeWorkInfo.assignmentModel * 1), 'apiListDetail(data.data.list, this.homeWorkInfo.assignmentModel * 1)');
    console.log(this.homeWorkInfo.assignmentModel, 'this.homeWorkInfo.assignmentModel');
    Object.assign(this.data, {
      list: apiListDetail(data.data.list, this.homeWorkInfo.assignmentModel * 1),
    });
    this.data.pagination.totalRecords = data.data.totalRecords;
  }

  async delJobDetailListItem() {
    this.deleting.value = true;
    await mock.post(mockPath.delJobDetailListItem, [1]);
    this.deleting.value = false;
  }
}

export class JobDetailListController {
  jobDetailList!: JobDetailList;

  router!: Router

  route!: RouteLocationNormalizedLoaded;

  activeJobDetail!: JobDetailListItem;

  constructor(jobDetailList: JobDetailList) {
    this.jobDetailList = jobDetailList;
    this.router = useRouter();
    this.route = useRoute();
    this.initDetail();
    this.jobDetailList.queryJobDetailList();
  }

  async initDetail() {
    // console.log('inittt', toRaw(this.route.query), this.route.params);
    this.jobDetailList.assignInfo.id = this.route.query.assignmentId as string; // 设置案例分析id-jobId
    this.jobDetailList.assignInfo.jobName = this.route.query.assignmentName as string; // 案例分析name
    this.jobDetailList.homeWorkInfo.id = this.route.params.expId as string; // 这里表示的是 被分配的id
    this.getJobView(this.route.params.expId as string);
    this.jobDetailList.homeWorkInfo.jobName = this.route.query.jobName as string;
  }

  gotoJobView() {
    const path = this.route.query.redirect || '/Teacher/caseAnalysis';
    this.router.push(path as string);
  }

  handlePageChange(pageNo: number) {
    this.jobDetailList.data.pagination.pageNo = pageNo;
    this.jobDetailList.queryJobDetailList();
  }

  handleViewClick(record: JobDetailListItem) {
    // console.log(record, 'recordd', this.route.query, this.route.params);
    Object.assign(this.jobDetailList.activeJobDetail, record);
    this.jobDetailList.activeJobDetailId.value = record.id;
    // this.router.push({
    //   path: `/Teacher/jobPreview/${this.jobDetailList.homeWorkInfo.id}`,
    //   query: {
    //     ...record,
    //     view: 'see', // preview,see,submit
    //     redirect: this.route.fullPath,
    //   },
    // });
    this.router.push({
      path: '/Teacher/analysisAnswer',
      query: {
        ...record,
        view: 'see', // preview,see,submit
        jobId: this.jobDetailList.assignInfo.id, // jobId这是教师端的作业id
        assignmentId: record.assignId, // 这是分配表的id
        // assignmentModel: record.assignmentModel, // 分配模式 —— 学生submit才需要分配模式
        stuCode: record.userId, // 查询指定学生的code —— 只有教师端批改才需要
        redirect: this.route.fullPath,
      },
    });
  }

  async handleRelease() {
    this.jobDetailList.loadings.release = true;
    try {
      // const { data } = await mock.post(mockPath.getJobDetailList, {});
      const { data } = await axios.savePublishStates(this.jobDetailList.homeWorkInfo.id);
      if (data.success) {
        this.jobDetailList.homeWorkInfo.gradeStatus = 1;
        await this.getJobView(this.jobDetailList.homeWorkInfo.id);
        message.success('发布成功！');
      }
    } catch (error) {
      console.log(error);
    }
    this.jobDetailList.loadings.release = false;
  }

  async getJobView(jobId: string) {
    try {
      const { data } = await axios.queryAssignHomeworkById(jobId);// 该接口只查询jobView，所以没有assignName
      const assignData = apiQueryJobView(data.data as definitions['AssignHomework']);
      console.log('before', data.data, '\nafter', assignData);
      this.jobDetailList.homeWorkInfo.id = assignData.id!; // .assignmentId!;
      this.jobDetailList.homeWorkInfo.assignmentModel = assignData.assignmentModel as 0|1;
      this.jobDetailList.homeWorkInfo.gradeStatus = assignData.gradeStatus as 0|1 || 0;
      this.jobDetailList.homeWorkInfo.assignStatus = assignData.assignStatus as 0 | 1 | 2;
      return data.data;
    } catch (error) {
      console.log(error);
      return {};
    }
  }
}
